import { ISettings } from 'src/app/core/interfaces';
// import { environment } from 'src/environments/environment';
import { ReadingBase, ReadingEcho, ReadingMode, ReadingUnitType } from 'src/app/core/reading-utils/enums';
import { LookupDialogType } from 'src/app/components/lookup/lookup';
import { PdfStrokeColor, PdfFitModes, PdfViewerLayoutModes, NavigationModes } from 'src/app/core/pdf-utils/enums';
import { TextNotesFontTypeStyle } from 'src/app/core/enums';
import { textNotesFonts } from 'src/app/core/common';
import { CloudServiceEnum } from '../cloud-storage/enums/cloud-service.enum';
import { CloudFoldersEnum } from '../../utils/enums/cloud-folders.enum';


export const DefaultSettings: ISettings = {
  savedLanguage: '', // environment.defaultLangCode,
  UILanguageValue: '', // environment.defaultLangCode,
  savedVoice: 'Claire',
  UIVoice: 'Claire',
  speed: 0,
  wordsReadingPause: 0,
  readWhileTyping: true,
  readTooltips: false,
  readMenuItems: false,
  typingUnit: ReadingEcho.Word,
  readingUnit: ReadingUnitType.Sentence,
  readingMode: ReadingMode.ClickToPlay,
  editorReadingMode: ReadingMode.ClickToPlay,
  epubReadingMode: ReadingMode.ClickToPlay,
  readingBase: ReadingBase.Continuous,
  currentWordColor: '#0FF000',
  readingUnitColor: '#FFFF00',
  darkMode: false,
  audioFileTypeFormat: 0,
  cloudSettings: {
    cloudStorage: CloudServiceEnum.CloudStorage,
    cloudFolder: CloudFoldersEnum.Recent,
    recentPath: [],
  },
  cloudRecentFiles: [],
  cloudFavoriteFolders: [],
  lookup: {
    explDictFilter: '',
    picDictSelection: '',
    txtDictSelection: '',
    lkpTabSelection: LookupDialogType.Text
  },
  drawingStyles: {
    strokeColor: PdfStrokeColor.Black,
    strokeThickness: 1
  },
  drawingsVisible: true,
  textTools: {
    fontFamily: textNotesFonts[0],
    fontSize: 12,
    color: PdfStrokeColor.Black,
    fontType: TextNotesFontTypeStyle.NORMAL
  },
  spellCheckOn: true,
  wordPredictionOn: false,
  autoSave: true,

  savedFitMode: PdfFitModes.FitPage,
  savedLayoutMode: PdfViewerLayoutModes.Continuous,
  savedZoom: 100,
  pageNavigationMode: NavigationModes.CONTINUOUS,

  readWordPredictions: true,
  readSpellChecks: true,

  featureRestrictionPresets: [],
  examLastRestrictionTemplate: '',
  
  extractSettings: {
    withColor: true,
    withFormatting: true
  }
};
